<template>
    <div>
      <trademark-provisional-status-list></trademark-provisional-status-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  